"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormTipologia = void 0;

var _react = _interopRequireDefault(require("react"));

var _ModalFormTipologia = _interopRequireDefault(require("./ModalFormTipologia"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class FormTipologia extends _react.default.Component {
  constructor(props) {
    super(props);
    this.onChangeSelect = this.onChangeSelect.bind(this);
    this.onBlurInput = this.onBlurInput.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
    this.editValue = this.editValue.bind(this);
    this.agregarUnidad = this.agregarUnidad.bind(this);
    this.onChangeCant = this.onChangeCant.bind(this);
    this.validate = this.validate.bind(this);
    this.onBlurInputUnidad = this.onBlurInputUnidad.bind(this);
    this.onDeleteUnidad = this.onDeleteUnidad.bind(this);
    let idTipologia = 't-' + Math.random();
    let idUnidad = 'u-' + Math.random(); //en caso de que este entrando por primera vez le asigno los id de lo que tiene en la db

    if (this.props.primeraVez.value) {
      idTipologia = this.props.primeraVez.idTipologia;
      idUnidad = this.props.primeraVez.idUnidad;
    }

    let tipologiaVacia = {
      id: idTipologia,
      nombre: '',
      capacidad_max: null,
      dormitorios: null,
      banios: null,
      descripcion: '',
      new: 1,
      edit: 0,
      unidades: [{
        id: idUnidad,
        id_tipologia: idTipologia,
        nombre: ''
      }]
    };
    let t = this.props.tipologia;

    if (!t) {
      //en caso de que no exista tipologia creo una nueva
      t = tipologiaVacia;
    } else if (this.props.tipologia && !this.props.tipologia.edit) {
      //en caso de que se este editando por primera vez le agrego las variables de control
      t = { ...this.props.tipologia,
        new: 0,
        edit: 0,
        delete: 0
      };
    }

    this.state = {
      tipologia: t,
      cant: 1,
      errors: {
        nombreTipologiaError: false,
        capacidadError: false,
        dormitorioError: false,
        baniosError: false
      }
    };
  }

  onChangeSelect({
    target: {
      value,
      name
    }
  }) {
    this.editValue(name, value);
  }

  onBlurInput(event) {
    const value = event.target.value;
    const name = event.target.getAttribute('data-estado');
    this.editValue(name, value);
  }

  editValue(name, value) {
    let t = this.state.tipologia;
    this.setState({
      tipologia: { ...t,
        [name]: value,
        edit: 1
      }
    });
  }

  onChangeCant(event) {
    this.setState({
      cant: event.target.value
    });
  }

  agregarUnidad() {
    let tipoACambiar = this.state.tipologia;
    let cantAgregar = this.state.cant;
    let unidadesAEditar = Object.assign([], tipoACambiar['unidades']);

    for (var i = 0; i < cantAgregar; i++) {
      const idUnidad = 'u-' + Math.random();
      unidadesAEditar.push({
        id: idUnidad,
        id_tipologia: tipoACambiar.id,
        nombre: '',
        delete: 0
      });
    }

    let tipologia = { ...tipoACambiar,
      unidades: unidadesAEditar,
      edit: 1
    };
    this.setState({
      tipologia
    });
  }

  onBlurInputUnidad(id, value) {
    let tipoACambiar = this.state.tipologia;
    let unidadesACambiar = Object.assign([], tipoACambiar.unidades);
    const unidadesCambiada = unidadesACambiar.map(u => {
      if (u.id == id) {
        return {
          id: u.id,
          id_tipologia: tipoACambiar.id,
          nombre: value,
          delete: u.delete ? u.delete : 0
        };
      }

      return u;
    });
    let tipologia = { ...tipoACambiar,
      unidades: unidadesCambiada,
      edit: 1
    };
    this.setState({
      tipologia
    });
  }

  onDeleteUnidad(id) {
    let esNuevo = String(id).substr(0, 1) === 'u';
    let tipoACambiar = this.state.tipologia;
    let unidadesACambiar = Object.assign([], tipoACambiar.unidades);
    let unidadesCambiada = null;

    if (!esNuevo) {
      unidadesCambiada = unidadesACambiar.map(u => {
        if (u.id == id) {
          return {
            id: u.id,
            id_tipologia: tipoACambiar.id,
            nombre: u.nombre,
            delete: 1
          };
        }

        return u;
      });
    } else {
      unidadesCambiada = unidadesACambiar.filter(u => {
        return u.id != id;
      });
    }

    let tipologia = { ...tipoACambiar,
      unidades: unidadesCambiada,
      edit: 1
    };
    this.setState({
      tipologia
    });
  }

  validate() {
    const {
      tipologia
    } = this.state;
    this.setState({
      errors: {
        nombreTipologiaError: tipologia.nombre ? false : true,
        capacidadError: tipologia.capacidad_max ? false : true,
        dormitorioError: tipologia.dormitorios != null ? false : true,
        baniosError: tipologia.banios != null ? false : true
      }
    });

    if (!tipologia.nombre || !tipologia.capacidad_max || tipologia.dormitorios == null || tipologia.banios == null) {
      return false;
    }

    return true;
  }

  onClickSave() {
    let tipoACambiar = this.state.tipologia;
    let unidadesACambiar = Object.assign([], tipoACambiar.unidades); //si no se le puso nombre a la unidad se setea el nombre como "Unidad Sin Nombre" por defecto

    unidadesACambiar.forEach(u => {
      if (!u.nombre) {
        u.nombre = 'Unidad Sin Nombre';
      }
    });
    let tipologia = { ...tipoACambiar,
      unidades: unidadesACambiar
    }; //valido que los campos obligatorios esten seteados y si esta todo correcto guardo el estado

    if (this.validate()) {
      this.setState({
        tipologia
      }, () => this.props.guardar(this.state.tipologia));
    }
  }

  render() {
    const {
      open,
      openModal
    } = this.props;
    const {
      tipologia,
      cant,
      errors
    } = this.state;
    return (0, _react2.jsx)(_ModalFormTipologia.default, {
      open: open,
      openModal: openModal,
      onChangeSelect: this.onChangeSelect,
      onBlurInput: this.onBlurInput,
      capacidad_max: tipologia ? tipologia.capacidad_max : null,
      dormitorios: tipologia ? tipologia.dormitorios : null,
      banios: tipologia ? tipologia.banios : null,
      nombre: tipologia ? tipologia.nombre : null,
      descripcion: tipologia ? tipologia.descripcion : null,
      unidades: tipologia ? tipologia.unidades : null,
      guardar: this.onClickSave,
      agregarUnidad: this.agregarUnidad,
      onChangeCant: this.onChangeCant,
      onBlurInputUnidad: this.onBlurInputUnidad,
      onDeleteUnidad: this.onDeleteUnidad,
      cant: cant,
      errors: errors
    });
  }

}

exports.FormTipologia = FormTipologia;
var _default = FormTipologia;
exports.default = _default;